import type { App } from 'vue'
import { surveyPlugin } from 'survey-vue3-ui'

export default (app: App) => {
  app.use(surveyPlugin)
}
